<template>
  <Wrapper
    v-show="!preview && renderTools && gridActive.id"
    :position="gridActive.position"
    id="grid-active-frame"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    :isActiveWidget="!!widgetActive.id"
  >
    <!-- <GridHover class="active lbl-name" >
      <b-dropdown :dropup="!isOverScroll" :dropdown="isOverScroll">
        <template #button-content>
          Grid <i class="fas" :class="{'fa-caret-up': !isOverScroll, 'fa-caret-down': isOverScroll}"></i>
        </template>
        <b-dropdown-item @click="goTo('section')">Section</b-dropdown-item>
      </b-dropdown>
    </GridHover> -->
    <fragment
      v-if="isOverlap && sectionActive.id">
      <GridHover class="lbl-name disabled lbl-hover" @click="goTo('section')">
        {{ $t('engine.floatframeTool.floatframeHover.section.lblSection', languageEngine) }}
      </GridHover>
      <GridHover class="active lbl-name" style="left: 72px;">
        {{ $t('engine.floatframeTool.floatframeHover.grid.lblGrid', languageEngine) }}
      </GridHover>
    </fragment>
    <GridHover class="active lbl-name" :class="{'disabled lbl-hover': widgetActive.id}" @click="widgetActive.id && goTo('grid')" v-else>
      {{ $t('engine.floatframeTool.floatframeHover.grid.lblGrid', languageEngine) }}
    </GridHover>
    <Reheight v-if="detectDevice !== 'mobile' && !widgetActive.id" :component_id="gridActive.id" />
    <GridTool :key="gridToolKey" v-if="detectDevice !== 'mobile' && !widgetActive.id && !['reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)" class="d-flex align-items-center grid-tool">
      <div
        class="d-flex justify-content-center align-items-center btn-tool-wrapper"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.grid.miniBtn.btnDuplicateGrid', languageEngine)"
        @click.stop.prevent="duplicateGrid"
      >
        <i class="icon-fa mt-1 far fa-clone"></i>
      </div>

      <div
        class="justify-content-center align-items-center btn-tool-wrapper d-flex"
        v-b-tooltip.hover
        :class="{'disabled': !isShowUp}"
        :style="`pointer-events: ${!isShowUp ? 'none' : 'all'}`"
        :title="$t('engine.floatframeTool.floatframeActive.grid.miniBtn.btnUpGrid', languageEngine)"
        @click.stop.prevent="moveGridUp"
      >
        <i class="icon-fa mt-1 far fa-arrow-up"></i>
      </div>

      <div
        class="justify-content-center align-items-center btn-tool-wrapper d-flex"
        v-b-tooltip.hover
        :class="{'disabled': !isShowDown}"
        :style="`pointer-events: ${!isShowDown ? 'none' : 'all'}`"
        :title="$t('engine.floatframeTool.floatframeActive.grid.miniBtn.btnDownGrid', languageEngine)"
        @click.stop.prevent="moveGridDown"
      >
        <i class="icon-fa mt-1 far fa-arrow-down"></i>
      </div>

      <div
        class="d-flex justify-content-center align-items-center btn-tool-wrapper"
        @click.stop.prevent="removeGrid"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.grid.miniBtn.btnRemoveGrid', languageEngine)"
      >
        <i class="icon-fa far fa-trash-alt mt-1"></i>
      </div>
    </GridTool>

     <!-- Toolbar -->
    <div id="grid-tool-pill" v-if=" detectDevice == 'mobile' && !widgetActive.id" class="d-flex align-items-center widget-tool" style="z-index: 5;">
      <b-badge id="grid-tool-badge"
        pill
        variant="light"
        class="d-flex align-items-center mb-10 my-2"
      >
        <span>Grid Display</span>
        <div class="tool-vl"></div>
        <div class="layout-select-wrapper">
          <div class="option-layout"
            v-for="(item, index) in optionDisplay"
            :key="`${index}_select`"
            :class="{'active': item.layout == layoutSelected}"
            @mouseover="optionHover(item.layout)" 
            @mouseleave="optionLeave(item.layout)"
            @click="selectLayout(item.layout)"
          >
            <div v-show="item.action == 'default' && item.layout != layoutSelected">
              <img :src="require(`./iconTool/layout_${item.layout}_default.svg`)"/>
            </div>
            <div v-show="item.action == 'hover' || item.layout == layoutSelected">
              <img :src="require(`./iconTool/layout_${item.layout}_hover.svg`)"/>
            </div>
  
          </div>
        </div>
      </b-badge>
    </div>
  </Wrapper>
</template>

<script>
import { GridHover } from "./GridHover.styled";
import Reheight from "./Reheight";
import { GridTool, Wrapper } from "./GridActive.styled";

import { mapGetters } from "vuex";

import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

import gridLayoutConfig from "@model/layoutConfigs/grid";

export default {
  components: {
    GridHover,
    Reheight,
    GridTool,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
      gridToolKey: 0,
      options: [
        { layout: '01', action: 'default' },
        { layout: '02', action: 'default' },
        { layout: '03', action: 'default' },
        { layout: '04', action: 'default' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      scrollPosition: "scrollPosition",
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetActive: "designIframe/frame/widgetActive",
      sectionActive: "designIframe/frame/sectionActive",
      gridActive: "designIframe/frame/gridActive",
      gridHover: "designIframe/frame/gridHover",
      cellActive: "designIframe/frame/cellActive",
      cellHover: "designIframe/frame/cellHover",
      components: "designIframe/metadata/components",
      detectDevice: "detectDevice",
      mode: "designIframe/mode",
      languageEngine: "designIframe/userPreference/languageEngine",
      limit: "designIframe/page/limit",
    }),
    parent_id() {
      return this.gridActive.id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.gridActive.id)
      )[0][0];
    },
    sectionComponent() {
      return this.parent_id && this.components[this.parent_id]
    },
    gridMarginTop() {
      return (
        this.components[this.gridActive.id] &&
        this.components[this.gridActive.id].style.marginTop
      );
    },
    isOverScroll() {
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    indexGrid() {
      return this.sectionComponent && this.sectionComponent.componentsID.indexOf(this.gridActive.id);
    },
    isFirstIndex() {
      return this.indexGrid == 0;
    },
    isLastIndex() {
      return (
        this.sectionComponent && this.sectionComponent.componentsID.length - 1 == this.indexGrid
      );
    },
    isShowUp() {
      let show = true;
      if (this.isFirstIndex) {
        show = false;
      }
      return show;
    },
    isShowDown() {
      let show = true;
      if (this.isLastIndex) {
        show = false;
      }
      return show;
    },
    isOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isFirstIndex && this.gridMarginTop == 0
    },
    layoutSelected() {
      return this.gridActive.id && this.components[this.gridActive.id].styleMobile.layout
    },
    allowLayout() {
      return this.components[this.gridActive.id] && gridLayoutConfig[this.components[this.gridActive.id].style.layout].gridMobile.allowLayout
    },
    optionDisplay() {
      let opDisplay = [];
      if(this.allowLayout) {
        this.options.map(item => {
          if (this.allowLayout.indexOf(item.layout) > -1) opDisplay.push(item);
        })
      }
      return opDisplay
    }
  },
  watch: {
    scrollPosition() {
      this.$nextTick(function () {
        this.resetGridActivePosition();
      });
    },
    mode() {
      this.$nextTick(function () {
        this.resetGridActivePosition();
      });
    },
    gridMarginTop() {
      this.$nextTick(function () {
        this.resetGridActivePosition();
      });
    },
    gridActive: {
      deep: true,
      handler() {
        const element = document.getElementById("grid-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
            this.reRenderComponent();
          })
        }
      }
    }
  },
  methods: {
    reRenderComponent() {
      this.gridToolKey += 1;
    },
    duplicateGrid() {
      const gridCountInSection = this.sectionComponent.componentsID.length;
      if(!this.limit.grid || gridCountInSection < this.limit.grid) {
        this.$store.dispatch("designIframe/component/duplicateComponent", {
          component_id: this.gridActive.id,
          parent_id: this.parent_id,
        });
        this.$store.dispatch("designIframe/snapshot/genSnapshot");
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-grid",
          payload: {},
        });
      }
    },
    resetGridActivePosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.gridActive.id,
        type: "GRID",
        action: "ACTIVE",
      });
    },
    removeGrid() {
      this.$store.dispatch("designIframe/component/removeComponent", {
        id: this.gridActive.id,
        parent_id: this.parent_id,
      });
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
    },
    resetGridToolPosition() {
      this.$store.dispatch("designIframe/frame/setCellHover", {
        component_id: this.cellHover.id,
      });
      this.$store.dispatch("designIframe/frame/setCellActive", {
        component_id: this.cellActive.id,
        parent_id: this.gridActive.id,
      });
    },
    moveGridUp() {
      if (!this.isShowUp) return
      this.$store.dispatch("designIframe/component/moveGridUp", {
        id: this.gridActive.id,
        parent_id: this.parent_id,
      });

      this.$nextTick(() => {
        this.resetGridToolPosition();
      });
    },
    moveGridDown() {
      if (!this.isShowDown) return
      this.$store.dispatch("designIframe/component/moveGridDown", {
        id: this.gridActive.id,
        parent_id: this.parent_id,
      });
      this.$nextTick(() => {
        this.resetGridToolPosition();
      });
    },
    goTo(type) {
      switch (type) {
        case "section": {
          var compID = this.parent_id;

          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: compID,
            name: compID,
          });
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setCellActive", {});
          this.$store.dispatch("designIframe/frame/setCellHover", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

          let noneSetting = false;
          SECTION_TYPE_NONE_SETTING.find((type) => {
            Object.entries(this.components).forEach((item) => {
              if (type === item[1].type && item[1].id === this.parent_id) {
                noneSetting = true;
              }
            })
          });
          if (noneSetting) {
            this.$store.dispatch("design/component/elActive", {});
          } else {
            this.$store.dispatch("design/component/elActive", {
              elementID: ["component", compID],
            });
          }
          this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
          break;
        }
        case "grid": {
          if (this.cellActive.id && this.gridActive.id) {
            this.$store.dispatch("designIframe/frame/setSectionActive", {
              component_id: this.parent_id,
              name: this.parent_id,
            });
            this.$store.dispatch("designIframe/component/elActive", {
              elementID: ["component", this.cellActive.id],
            });
            this.$store.dispatch("designIframe/frame/setCellActive", {
              component_id: this.cellActive.id,
              parent_id: this.gridActive.id,
            });
          }
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {})
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
          this.$store.dispatch("designIframe/frame/setSectionHover", {});
          this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
          break;
        }
        default:
          break;
      }
    },
    optionHover(layout) {
      this.options.forEach(item => {
        if (item.layout == layout) {
          item.action = 'hover'
        }
      });
    },
    optionLeave(layout) {
      this.options.forEach(item => {
        if (item.layout == layout) {
          item.action = 'default'
        }
      });
    },
    selectLayout(layout) {
      this.components[this.gridActive.id].styleMobile.layout = layout
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.options.forEach(item => {
        if (item.layout == layout) {
          item.action = 'active'
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-tool-wrapper {
    &.disabled {
      .icon-fa {
        color: #AEB5BD
      }
    }
  }
  #grid-tool-pill {
    pointer-events: all;
    position: absolute;
    left: 50%;
    top: -30px;
    transform: translate(-50%);
    justify-content: center;
    /* width: fit-content; */
    /* padding: 5px; */
    /* border-radius: 0px 0px 0px 5px; */
    right: 0;
    /* opacity: 0; */
    transition: all 0.1s ease;
    line-height: 1;
    font-size: 20px;

    /* margin-right: 4px; */
    .badge {
      padding: 4px 16px;
      height: 32px;
      gap: 10px;
      position: absolute;
      box-shadow: 0px 8px 16px 0px #00000026;
      font-family: "MWE_DB_Heavent";
      font-size: 20px;
      line-height: 20px;
      &.top {
        bottom: 10px;
      }
      &.bottom {
        top: 10px;
        &.header-widget {
          top: 24px;
        }
      }
      .tool-vl {
        height: 16px;
        border-left: 1px solid #DFDFDF;
      }
      .btn-tool {
        .icon {
          width: 16px;
          height: 16px;
          svg {
            width: 16px;
          }
        }
        svg {
          width: 16px;
        }
      }
      .btn-tool:hover {
        svg, .fs-db-20 {
          color: #24BEE2
        }
      }
      .layout-select-wrapper {
        display: flex;
        gap: 4px;
      }
    }
  }
</style>